import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getPigletFeedTypes, getPigletFeedTypesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_PIGLET_FEED_TYPES } from "consts";

import { PigletFeedType } from "models";

export const useGetPigletFeedTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("piglet", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((feedTypes: PigletFeedType[]) => injectNames(feedTypes, t, "feedTypes"), [t]);

  return useQuery({
    queryKey: [GET_PIGLET_FEED_TYPES, { enabled }, isAdmin],
    queryFn: () => (isAdmin ? getPigletFeedTypesAdmin({ enabled }) : getPigletFeedTypes({ enabled })),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
